import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiSearchApi, AiSearchApiImpl } from './apis';

export const aiSearchContainer = new ContainerModule((bind) => {
    bind<AiSearchApi>(AiSearchApi).to(AiSearchApiImpl);
});

export { AiSearchApi } from './apis';
